// extracted by mini-css-extract-plugin
export default {"handle":"DragHandleBar_handle__B2v-F"};